import { Button } from '@mui/material'
import { useNavigate, useRouteError } from 'react-router-dom'

function RootErrorBoundry() {
  const error = useRouteError() as Error
  const navigate = useNavigate()

  const handleReloadApp = () => {
    navigate('/')
  }

  return (
    <div className="flex flex-col gap-2">
      <h1>Oops Something went wrong!</h1>
      <pre>{error.message || JSON.stringify(error)}</pre>
      <Button onClick={handleReloadApp}>Click here to reload the app</Button>
    </div>
  )
}

export default RootErrorBoundry
